<template>
  <Modal :name="nameModal">
    <div class="text-center flex flex-col items-center">
      <Typography class="mt-8">
        {{
          $i18n(
            "Cette action n'est pas disponible pour le moment, veuillez contacter le support pour effectuer la modification.",
          )
        }}
      </Typography>

      <div>
        <Typography tag="div">
          {{ $i18n('Le numéro sur lequel joindre notre équipe est le :') }}
        </Typography>

        <Typography tag="div" variant="h3" class="my-4">
          {{ $i18n('09 70 25 44 04') }}
        </Typography>

        <div class="mb-6">
          <Typography tag="div" class="mb-3">
            {{ $i18n('Sur les créneaux suivants :') }}
          </Typography>

          <Typography tag="div">
            {{ $i18n('10h - 13h & 14h - 18h30 > Du lundi au jeudi') }}
          </Typography>

          <Typography tag="div">
            {{ $i18n('10h - 13h & 14h30 - 18h30 > Le vendredi') }}
          </Typography>
        </div>
      </div>

      <a
        class="text-xs my-0 flex items-center mb-6"
        href="https://japhyhelp.zendesk.com/hc/fr"
        target="_blank"
        rel="noopener noreferrer"
      >
        <MailIcon :class="$style.contactIcon" />

        <span>Nous contacter</span>
      </a>

      <Button @click="$store.dispatch('modal/close', nameModal)">
        {{ $i18n('Fermer') }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import { Modal, Typography } from '@front/ui'
import { defineComponent } from '@vue/composition-api'
import { MailIcon } from 'vue-feather-icons'

export default defineComponent({
  components: { Typography, MailIcon, Modal },
  props: {
    nameModal: {
      type: String,
      required: true,
    },
  },
})
</script>

<style lang="scss" module>
.contactIcon {
  width: 16px;
  margin-right: 5px;
}
</style>
